// extracted by mini-css-extract-plugin
export default {"container":"ChatPanelContent_container__yC8Hc","content":"ChatPanelContent_content__CMQru"};